import axios from "axios";

const UPLOAD_URL =
  "https://53fde1b606cff91e7a3b23ff9c242152.grupoalianzacolombia.com/upload.php";

const ELITE_BANNERS_UPLOAD_DIR = "imagenes_banners_elite";

const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];

const uploadBannerImageElite = async (file) => {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new Error(
      "Formato no permitido. Usa JPG, PNG, GIF o WEBP.",
    );
  }

  const formData = new FormData();
  formData.append("fileToUpload", file);
  formData.append("uploadDir", ELITE_BANNERS_UPLOAD_DIR);

  try {
    const response = await axios.post(UPLOAD_URL, formData);
    const url = response.data?.data?.fileUrl;

    if (!url) {
      throw new Error(
        response.data?.message || "El servidor no devolvió la URL de la imagen",
      );
    }

    return url;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Error al subir la imagen";

    throw new Error(message);
  }
};

export { uploadBannerImageElite, ELITE_BANNERS_UPLOAD_DIR, ALLOWED_IMAGE_TYPES };
